import React from 'react';
import Carousel from './Carousel';
import AboutUsHome from '../pages/AboutUshome';
import TopDestinations from '../pages/TopDestinations';
import Topattraction from '../pages/Top Attractions';
import BestTour from '../pages/BestTour';
import LastMinuteDeals from '../pages/LastMinuteDeals';
import Testimonials from '../pages/Testimonials';
import OurTeam from '../pages/OurTeam';

const Hero = () => {
  return (
    <div>
<Carousel/>
<AboutUsHome/>
<TopDestinations/>
<Topattraction/>
<BestTour/>
<LastMinuteDeals/>
<Testimonials/>
<OurTeam/>

    </div>
  );
};

export default Hero;
